import { showStep } from './ui.js';

let currentStep = 0;
let totalSteps = 0;
let steps = null;
let stepSegments = null;
let currentStepText = null;

/**
 * Initialize navigation with DOM elements
 * @param {Object} elements - Object containing DOM element references
 */
export function initNavigation(elements) {
	steps = elements.steps;
	stepSegments = elements.stepSegments;
	currentStepText = elements.currentStepText;
	totalSteps = steps.length;
	currentStep = 0;
}

/**
 * Setup next button click handlers
 * @param {NodeList} nextBtns - All next buttons
 */
export function setupNextButtons(nextBtns) {
	nextBtns.forEach(btn => {
		btn.addEventListener('click', () => {
			if (currentStep < totalSteps - 1) {
				currentStep++;
				showStep(currentStep, steps, stepSegments, currentStepText);
			}
		});
	});
}

/**
 * Setup back button click handlers
 * @param {NodeList} backBtns - All back buttons
 */
export function setupBackButtons(backBtns) {
	backBtns.forEach(btn => {
		btn.addEventListener('click', () => {
			if (currentStep > 0) {
				currentStep--;
				showStep(currentStep, steps, stepSegments, currentStepText);
			}
		});
	});
}

/**
 * Show initial step
 */
export function showInitialStep() {
	showStep(0, steps, stepSegments, currentStepText);
}
